/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var CardBox, PureRenderMixin, React, ReactDOM, css;

React = require('react');

ReactDOM = require('react-dom');

PureRenderMixin = require('react-addons-pure-render-mixin');

CardBox = require('./card-box');

css = require('../css/card-group.styl');

module.exports = React.createClass({
  mixins: [PureRenderMixin],
  getDefaultProps: function() {
    return {
      customClassNames: [],
      pickId: null,
      didClick: null,
      pickedCards: []
    };
  },
  displayName: 'CardGroup',
  handleClick: function() {
    var base;
    if (typeof (base = this.props).didClick === "function") {
      base.didClick(this.props.pickId);
    }
  },
  getFullClassName: function() {
    var classes;
    classes = [css['card-group']].concat(this.props['customClassNames']);
    if (this.props.didClick != null) {
      classes.push(css['clickable']);
    }
    return classes = classes.join(' ');
  },
  renderCardBoxes: function() {
    return this.props.pickedCards.map((function(_this) {
      return function(cardId) {
        var card;
        card = _this.props.cards.items[cardId];
        return React.createElement(CardBox, {
          "key": card.id,
          "id": card.id,
          "type": card.type,
          "customClassNames": [css['card']]
        }, card.value);
      };
    })(this));
  },
  render: function() {
    return React.createElement("div", {
      "className": this.getFullClassName(),
      "onClick": this.handleClick
    }, this.renderCardBoxes());
  }
});


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "card-group.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/card-group.cjsx
 ** module id = 265
 ** module chunks = 0
 **/